import { Box, Typography } from '@mui/material';

import { warning } from '@/assets';
import { Button, LocalModal, ModalContentContainer } from '@/components';

export const ConfirmModal = ({
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  title,
  description,
}: {
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  title: string;
  description: string;
}) => {
  return (
    <LocalModal open onClose={onCancel}>
      <ModalContentContainer onModalClose={onCancel}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            alignItems: 'center',
            textAlign: 'center',
          }}>
          <Box
            component="img"
            src={warning}
            alt="assessment warning"
            width={82}
            height={82}
          />
          <Typography variant="h4" sx={{ color: 'secondary.main' }}>
            {title}
          </Typography>
          <Typography variant="body2">{description}</Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 2,
              width: '100%',
            }}>
            <Button
              skinny={false}
              variant="secondary"
              label={cancelText}
              onClick={onCancel}
            />
            <Button
              skinny={false}
              variant="primary"
              label={confirmText}
              onClick={onConfirm}
            />
          </Box>
        </Box>
      </ModalContentContainer>
    </LocalModal>
  );
};
